/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// component
import Auth from 'pages/auth/auth';



/* ========== ~~~~~~~~~~ AUTH : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus, sessionStatus }) => ({
    tokenData: authStatus.tokenData,
    showSetPassword: sessionStatus.showSetPassword,
    showTermsAndConditions: sessionStatus.showTermsAndConditions,
    isSignedIn: sessionStatus.isSignedIn
});
// map actions
// const mapDispatchToProps = dispatch => ({
//
// });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    // mapDispatchToProps
)(Auth));
